<template>
  <div class="InvestorContact" v-cloak>
    <div class="investor-nav">
      <div class="investor-nav-item">投资者联系</div>
    </div>
    <div class="contact-info">
      <div class="company-name">{{contactData['companyName']}}</div>
      <div class="company-info"><strong>合作热线：</strong>{{contactData['telephone']}}</div>
      <div class="company-info"><strong>总部地址：</strong>{{contactData['headAddress']}}</div>
      <div class="company-info"><strong>邮编：</strong>{{contactData['postcode']}}</div>
    </div>
    <baidu-map v-if="dataReady" class="bm-view" :center="center" :zoom="zoom" ak="HF3zAs9Y38nXY6AiPLDPztHepYqxadKI">
      <bm-marker :position="center" animation="BMAP_ANIMATION_BOUNCE"/>
    </baidu-map>
  </div>
</template>
<script>

  import BaiduMap from 'vue-baidu-map/components/map/Map.vue';
  import BmMarker from 'vue-baidu-map/components/overlays/Marker.vue';
  import Bus from '../../router/bus.js';

  /**
   * 投资者联系
   */
  export default {
    name: 'InvestorContact',
    components: {
      BaiduMap,
      BmMarker
    },
    data() {
      return {
        cat: 8000006,
        dataReady: false,
        contactData: {
          companyName: '',
          headAddress: '',
          mapAddress: '',
          mapCoordinate: '',
          postcode: '',
          telephone: ''
        },
        center: {
          lng: 22.574907,
          lat: 114.06686
        },
        zoom: 18
      }
    },
    created() {
      Bus.$emit('changeCat', this.cat)
      let url = this.$root.baseUrl + '/investorContact/get';
      this.axios.get(url)
        .then(res => {
          this.contactData = res['data'];
          let _coordinates = res['data']['mapCoordinate'].split(',')
          this.center = {
            lng: parseFloat(_coordinates[0]),
            lat: parseFloat(_coordinates[1])
          };
          this.dataReady = true;
          console.log(res);
        })
        .catch(e => {
          console.log(e);
        });
    }
  }
</script>
<style scoped>
  .investor-nav {
    padding: .6rem 5vw;
    background: #fff;
    box-shadow: 0 0 1rem rgba(0,0,0,0.1);
  }
  .investor-nav-item {
    border-left: 5px solid #ff7800;
    padding-left: .5rem;
    font-weight: 600;
  }
  .InvestorContact {
    font-size: 1rem;
  }
  .contact-info {
    margin: 1vh 5vw;
    width: 90vw;
    min-height: 9rem;
    box-sizing: border-box;
    padding: 1rem;
    border: 1px solid #eee;
    border-radius: 3px;
    box-shadow: 2px 2px 16px rgba(0,0,0,0.3);
    overflow: hidden;
    color: #666;
  }
  .company-name {
    font-size: 1rem;
    font-weight: 600;
    margin-bottom: .6rem;
  }
  .company-info {
    font-size: .9rem;
    line-height: 1.6rem;
  }
  .company-info strong {
    font-weight: 600;
    color: #888;
  }
  .bm-view {
    margin: 2rem 5vw 0 5vw;
    width: 90vw;
    height: 120vw;
    box-sizing: border-box;
    border: 1px solid #eee;
    border-radius: 3px;
    box-shadow: 2px 2px 16px rgba(0,0,0,0.3);
    overflow: hidden;
  }
</style>



// WEBPACK FOOTER //
// src/components/investor/InvestorContact.vue